import { render } from "./ProfitCenter.vue?vue&type=template&id=1ce7bdce&scoped=true"
import script from "./ProfitCenter.vue?vue&type=script&lang=js"
export * from "./ProfitCenter.vue?vue&type=script&lang=js"

import "./ProfitCenter.vue?vue&type=style&index=0&id=1ce7bdce&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce7bdce"]])

export default __exports__